<template>
    <div>
        <div>
            <el-input placeholder="Please enter infoID" v-model="infoID" suffix-icon="el-icon-search" @change="search" clearable
                style="width: 300px; margin-left: 5px;"></el-input>
            <el-date-picker style="margin-left:5px" v-model="date" type="daterange" range-separator="to"
                start-placeholder="start date" end-placeholder="end date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                @change="search">
            </el-date-picker>
            <el-button @click="search" style="margin-left:10px" @change="search" type="primary">search</el-button>
        </div>
        <div style="padding-top:5px;padding-bottom: 10px;">
            <el-button type="primary"  @click="exportData" icon="el-icon-upload2">Export</el-button>
        </div>
        <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50" align="center">
            </el-table-column>
            <el-table-column prop="infoID" label="InfoID" width="100"  align="center">
            </el-table-column>
            <el-table-column label="position" width="100" align="center" style="padding:0%">
                <template  slot-scope="scope">
                    <img v-if="$store.state.teb.default_active.charAt(0)==='3'" :src="getPartImage(scope.row)" alt="部位图片" style="width: 50px; height: 50px; padding: 0%;margin: 0%;">
                    <img v-else :src="getBlackPartImage(scope.row)" alt="部位图片" style="width: 90px; height: 150px;">
                </template>
            </el-table-column>
            <el-table-column label="energy" width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.energy + ' J/cm2' }}
                </template>
            </el-table-column>
            <el-table-column label="frequency" width="150" align="center"> 
                <template slot-scope="scope">
                    {{ scope.row.frequency + ' Hz' }}
                </template>
            </el-table-column>
            <el-table-column label="pulse width" width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.pulse + " ms" }}
                </template>
            </el-table-column>
            <el-table-column prop="temperature" label="temperature" width="150" align="center">
                <template slot-scope="scope">
                    {{ scope.row.temperature + " ℃" }}
                </template>
            </el-table-column>
            <el-table-column prop="flow" label="Water speed" width="150"  align="center">
            </el-table-column>
            <el-table-column prop="sc" label="usage count" width="150" align="center" >
            </el-table-column>
            <el-table-column prop="createDate" label="Creation date">
            </el-table-column>
        </el-table>
        <div style="padding:10px 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

    </div>
</template>
<script>
import request from '@/utils/request';
export default {
    data() {
        return {
            breadcrumb_teb:{},
            tableData: [],
            userID: this.$store.state.teb.white808UserID,
            machine: this.$store.state.teb.machineID,
            pageNum: 1,
            pageSize: 10,
            firstDate: '',
            lastDate: '',
            infoID: '',
            date:[],
            total:0,
            isBlack:this.$store.state.teb.default_active.charAt(0)==='3'?0:1
        }

    },
    methods: {
        async exportData() {
            if(this.$store.state.teb.default_active.charAt(0)==='3'){
                this.isBlack =0 ;
            }else{
                this.isBlack =1;
            }       
            try {
                const url = `https://www.qihang.store/sb/808user/export/userInfo?machine=${this.machine}&userID=${this.userID}&infoID=${this.infoID}&firstDate=${this.firstDate}&lastDate=${this.lastDate}&blackFlag=${this.isBlack}`;
                // 打开新窗口请求导出接口
                window.open(url);
            } catch (error) {
                console.error("Error:", error);
            }
        },
        search(){
            this.pageNum =1;
            this.load();
        },
        load() {
            if (this.date && this.date.length > 0) {
                if (this.date[0] && this.date[1]) {
                    this.firstDate = this.date[0];
                    this.lastDate = this.date[1];
                } else {
                    this.firstDate = '';
                    this.lastDate = '';
                }
            } else {
                this.firstDate = '';
                this.lastDate = '';
            }
            request.get("/808user/selectToIDUserInfo", {
                params: {
                    machine: this.machine,
                    userID: this.userID,
                    infoID: this.infoID,
                    firstDate: this.firstDate,
                    lastDate: this.lastDate,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }
            }).then(res => {
                const data = res.data || {}
                const isArray = Array.isArray(data)
                this.tableData = isArray ? data : (data.data || [])
                this.total = (isArray ? res.count : data.count) || 0
            })
        },
        getBlackPartImage(row){
            return require(`@/assets/positionImg/blackPosition/position${row.position}.png`)
        },
        getPartImage(row) {
            return require(`@/assets/positionImg/p${row.position}.png`)
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.load();
        },
        handleCurrentChange(pageNum) {
            this.pageNum = pageNum;
            this.load();
        },
        handleSelectionChange(val){
            this.multipleSelection = val
        },
    },
    created() {
        this.load()
        this.breadcrumb_teb.name = this.isBlack == 1 ? '808_B-userinfo' : '808_W-userinfo';
        this.breadcrumb_teb.pageFlag = 2
        this.breadcrumb_teb.machine = this.machine
        this.breadcrumb_teb.path='/white808userinfo'
        this.$store.commit('updateSecondTab',this.breadcrumb_teb)
    }
}
</script>
<style lang="less" >
 
    
</style>